import styled from 'styled-components';
import { css } from '../../../styles/theme';
import { LoadingButtonStyled } from '../LoadingButtonStyled';

export const LoadingButtonStyledDS = styled(LoadingButtonStyled)``;
